import React from "react";
import Button from "@mui/material/Button";
import { Link, useHistory } from "react-router-dom";
import Cookie from "js-cookie";
import "./styles.css";
import "./DesktopMenuModern.css";
import GroupIcon from "@mui/icons-material/Group";
import HomeIcon from "@mui/icons-material/Home";
import LogoutIcon from "@mui/icons-material/Logout";
import FileCopyIcon from "@mui/icons-material/FileCopy";
import AutoStoriesIcon from "@mui/icons-material/AutoStories";
import BookIcon from "@mui/icons-material/Book";
import Divider from "@mui/material/Divider";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import OneSignal from "react-onesignal";
import Support from "./main/Support";
import commonData, { isAdmin } from "../importanValue";
import { useWebsite } from "../context/WebsiteContext";
import { getWebsiteConfig } from "../websiteConfig";
// import { loadComponent } from "../App";
if (isAdmin()) {
  {
    OneSignal.sendTag("user", "admin");
  }
}

const DesktopMenu = () => {
  const history = useHistory();
  const { websiteId } = useWebsite();
  const config = getWebsiteConfig(websiteId);
  const token = Cookie.get("jwt_token");

  const isRajeshWebsite = true//  websiteId === 'exams-with-rajesh';

  const logoutUser = () => {
    Cookie.remove("jwt_token");
    localStorage.removeItem("num");
    localStorage.removeItem("sessionId");
    localStorage.removeItem("uid");
    localStorage.removeItem("name");
    history.replace(`/${websiteId}/login`);
  };

  return (
    <div className={isRajeshWebsite ? "desktop-menu-modern" : "desktop-menu-wrapper"}>
      {isRajeshWebsite ? (
        <>
          {/* Modern Design for exams-with-rajesh */}
          <div className="desktop-menu-header-modern">
            <Link to={`/${websiteId}`} className="desktop-menu-brand">
              <img
                src={config.logo}
                alt={config.name}
                className="desktop-menu-logo-modern"
              />
              <div className="desktop-menu-brand-text">
                <h1 className="desktop-menu-brand-title">{config.name}</h1>
                <p className="desktop-menu-brand-subtitle">{config.fullName}</p>
              </div>
            </Link>
          </div>

          <nav className="desktop-menu-nav-modern">
            {commonData.userMenu
              .filter((item) => {
                if (isAdmin()) {
                  return !["Result", "My Profile"].includes(item.name);
                }
                return true;
              })
              .map((eachMen) => {
              return eachMen.enabled ? (
                <Link
                  key={eachMen.url}
                  to={`/${websiteId}${eachMen.url}`}
                  className="desktop-menu-link-modern"
                  target={eachMen.openInNewTab ? "_blank" : ""}
                >
                  <span>{eachMen.name}</span>
                </Link>
              ) : null;
            })}

            {token !== undefined && isAdmin() && (
              <>
                <div className="desktop-menu-divider-modern"></div>
                {commonData.AdminMenu.map((eachMen) => {
                  return eachMen.enabled ? (
                    <Link
                      key={eachMen.url}
                      to={`/${websiteId}${eachMen.url}`}
                      className="desktop-menu-link-modern admin-link-modern"
                    >
                      <span>{eachMen.name}</span>
                    </Link>
                  ) : null;
                })}
              </>
            )}

            <div className="desktop-menu-divider-modern"></div>

            <a
              href="/privacy-policy.html"
              target="_blank"
              rel="noreferrer"
              className="desktop-menu-link-modern secondary-link-modern"
            >
              <span>Privacy Policy</span>
            </a>
            <a
              href="/terms-and-conditions.html"
              target="_blank"
              rel="noreferrer"
              className="desktop-menu-link-modern secondary-link-modern"
            >
              <span>Terms and Conditions</span>
            </a>
            <a
              href="/refund-policy.html"
              target="_blank"
              rel="noreferrer"
              className="desktop-menu-link-modern secondary-link-modern"
            >
              <span>Refund Policy</span>
            </a>

            {token !== undefined && (
              <>
                <div className="desktop-menu-divider-modern"></div>
                <button className="desktop-menu-link-modern logout-link-modern" onClick={logoutUser}>
                  <LogoutIcon fontSize="small" />
                  <span>Logout</span>
                </button>
              </>
            )}
          </nav>
        </>
      ) : (
        <>
          {/* Original Design for Other Websites */}
          <div className="desktop-menu-header">
            <Link to={`/${websiteId}`} style={{ textDecoration: 'none', display: 'flex', alignItems: 'center', padding: '10px' }}>
              <img
                src={config.logo}
                alt={config.name}
                className="desktop-menu-logo"
              />
              <div style={{ marginLeft: '12px' }}>
                <h1 style={{ margin: 0, fontSize: '18px', fontWeight: 700, color: '#fff' }}>{config.name}</h1>
                <p style={{ margin: 0, fontSize: '12px', color: '#94a3b8' }}>{config.fullName}</p>
              </div>
            </Link>
          </div>
          {/* <p className="heading-para telangana">ఆంధ్రప్రదేశ్</p>
            <h1 className="heading-title desktoptitle">నవచైతన్య కాంపిటీషన్స్</h1>
            <p className="heading-para desktoppara">చింతలపూడి , ఏలూరు జిల్లా</p> */}
          <Divider color="white" />
          {/* {isAdmin() && (
            <a
              href="https://books.navachaitanya.net/orders"
              target="_blank"
              rel="noreferrer"
              className="linkto"
            >
              <div className="deskmenustyle">
                <div className="deskmenuIcon">➤</div>
                <p className="deskmenuPara">View Book Orders List</p>
              </div>
            </a>
          )} */}
          {commonData.userMenu
            .filter((item) => {
              if (isAdmin()) {
                return !["Result", "My Profile"].includes(item.name);
              }
              return true;
            })
            .map((eachMen) => {
            return eachMen.enabled ? (
              <Link
                key={eachMen.url}
                to={`/${websiteId}${eachMen.url}`}
                className="linkto"
                target={eachMen.openInNewTab ? "_blank" : ""}
              >
                <div className="deskmenustyle">
                  <div className="deskmenuIcon">➤</div>
                  <p className="deskmenuPara">{eachMen.name}</p>
                </div>
              </Link>
            ) : null;
          })}

          {token !== undefined && (
            <>
              {isAdmin() && (
                <>
                  {commonData.AdminMenu.map((eachMen) => {
                    return eachMen.enabled ? (
                      <Link key={eachMen.url} to={`/${websiteId}${eachMen.url}`} className="linkto">
                        <div className="deskmenustyle admin-menu-item">
                          <div className="deskmenuIcon">➤</div>
                          <p className="deskmenuPara">{eachMen.name}</p>
                        </div>
                      </Link>
                    ) : null;
                  })}
                </>
              )}
              <div className="desksidemenulogout">
                <Button
                  variant="contained"
                  className="btn header-btns logout-btn-desktop"
                  onClick={logoutUser}
                >
                  <div className="deskmenustyle">
                    <div className="deskmenuIcon">
                      <LogoutIcon />
                    </div>
                    <p className="deskmenuPara">Logout</p>
                  </div>
                </Button>
              </div>
            </>
          )}
          <Divider color="white" style={{ margin: '15px 0' }} />
          <div className="desktop-menu-footer">
            <a
              href="/privacy-policy.html"
              target="_blank"
              rel="noreferrer"
              className="linkto"
            >
              <div className="deskmenustyle footer-link">
                <div className="deskmenuIcon">➤</div>
                <p className="deskmenuPara">Privacy Policy</p>
              </div>
            </a>
            <a
              href="/terms-and-conditions.html"
              target="_blank"
              rel="noreferrer"
              className="linkto"
            >
              <div className="deskmenustyle footer-link">
                <div className="deskmenuIcon">➤</div>
                <p className="deskmenuPara">Terms and Conditions</p>
              </div>
            </a>
            <a
              href="/refund-policy.html"
              target="_blank"
              rel="noreferrer"
              className="linkto"
            >
              <div className="deskmenustyle footer-link">
                <div className="deskmenuIcon">➤</div>
                <p className="deskmenuPara">Refund Policy</p>
              </div>
            </a>
          </div>
        </>
      )}
    </div>
  );
 
};

export default DesktopMenu;
